var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.89 96.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.47,57c-18,.5-28.7-12.41-30.24-24.79a28.47,28.47,0,0,1,52.7-18.27c6.31,10.48,6.16,27.31-8.42,38.27.18.53.37,1.11.59,1.69.57,1.56.47,1.87-1.09,2.55q-4.27,1.88-8.58,3.69a9.14,9.14,0,0,1-1.83.54c-1.56.28-2,0-2.4-1.51l-.5-1.85C30.68,57.24,30.61,57.19,30.47,57Zm24.29-28.4A26.33,26.33,0,1,0,28.47,54.82,26.38,26.38,0,0,0,54.76,28.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.51,96.35a12.45,12.45,0,0,1-1.28-1.21,2.83,2.83,0,0,1-.4-1.11Q36.9,79.74,33,65.45a11.29,11.29,0,0,1-.31-1.4c-.24-1.7-.12-2,1.46-2.47a43.11,43.11,0,0,0,9.4-4.09c2.16-1.24,3.16-.8,3.89,1.53q4.44,14.15,8.83,28.31c.6,2,.56,1.93-1,3.2a26.26,26.26,0,0,1-10.11,5.26C44.43,96,43.64,96.12,42.51,96.35ZM53.32,89c-3.11-9.87-6-19.74-9.31-29.57l-8.18,3.47a296.63,296.63,0,0,0,8.45,30.94A20.9,20.9,0,0,0,53.32,89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.76,28.59A26.33,26.33,0,1,1,28.45,2.11,26.33,26.33,0,0,1,54.76,28.59ZM51,28.4c.33-11.84-9.61-22.61-22.43-22.58A22.55,22.55,0,1,0,51,28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.32,89a20.9,20.9,0,0,1-9,4.84,296.63,296.63,0,0,1-8.45-30.94L44,59.44C47.27,69.27,50.21,79.14,53.32,89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,28.4A22.53,22.53,0,1,1,28.53,5.82C41.35,5.79,51.29,16.56,51,28.4ZM28.35,48.75A20.42,20.42,0,1,0,8.07,28.21,20.41,20.41,0,0,0,28.35,48.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71,27.25a12.23,12.23,0,0,1,.69-5.53,18.72,18.72,0,0,1,6.87-9.82c.92-.69,1.9-1.44,3.46-.68-.56.55-1,1-1.41,1.37A17.86,17.86,0,0,0,15.87,25C15.66,27.08,15.39,27.3,12.71,27.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.87,39.57c-2.08,1.28-2.81,1.2-3.76-1a20.89,20.89,0,0,1-1.55-5.22c-.36-2.36.35-2.84,2.67-2.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.2eeed95225fa1411dde659a5dc7949e1.svg";
export { ForwardRef as ReactComponent };